export const STATUS_ARRAY = [
  ["Aktywne", "active"],
  ["Oczekujące", "pending"],
  ["Nie aktywne", "deactivated"],
]

export const CITIZENSHIP_ARRAY = [
  ["Poland", "poland"],
  ["Germany", "germany"],
  ["Netherlands", "netherlands"],
  ["Czech", "czech"],
  ["Slovakia", "slovakia"],
  ["Denmark", "denmark"],
  ["Slovenia", "slovenia"],
  ["Great Britain", "great_britain"],
  ["Austria", "austria"],
  ["Ukraine", "ukraine"],
  ["Belarus", "belarus"],
  ["Romania", "romania"],
  ["Portugal", "portugal"],
  ["Spain", "spain"],
  ["Lithuania", "lithuania"],
  ["Bulgaria", "bulgaria"],
  ["Latvia", "latvia"],
  ["Estonia", "estonia"],
  ["Russia", "russia"],
  ["Norway", "norway"],
  ["Sweden", "sweden"],
  ["Other", "other"],
]

export const CURRENCY_ARRAY = [
  ["PLN", "pln"],
  ["EURO", "eur"],
  ["USD", "usd"],
]

export const CAST_ARRAY = [
  ["Jednoosobowa", "single_cast"],
  ["Dwuosobowa", "double_cast"],
]

export const EXPERIENCE_ARRAY = [
  ["Brak doświadczenia", "exp_no"],
  ["Doświadczenie podstawowe", "exp_junior"],
  ["Doświadczenie średnie", "exp_mid"],
  ["Doświadczenie zaawansowane", "exp_senior"],
]

export const COMPANY_TYPE_ARRAY = [
  ["Bezpośredni pracodawca", "direct_employer"],
  ["Agencja pracy", "agency_employer"],
]

export const YES_NO_ARRAY = [
  ["Yes", "yes"],
  ["No", "no"],
]

export const PARAMS_DRIVER_ARRAY = [
  ["ADR", "adr"],
  ["HDS", "hds"],
  ["Oferta otwarta dla obywateli spoza kraju", "foreignerFriendly"],
  ["Pomoc w uzyskaniu dokumentów", "documentsHelp"],
]

export const PARAMS_OTHERS_ARRAY = [
  ["Oferta otwarta dla obywateli spoza kraju firmy", "foreignerFriendly"],
]

export const WORKTYPES_DRIVER_ARRAY = [
  ["mon-fri", "mon_fri"],
  ["2/1", "2_1"],
  ["2/2", "2_2"],
  ["3/1", "3_1"],
  ["4/1", "4_1"],
  ["4/2", "4_2"],
  ["6/2", "6_2"],
  ["8/4", "8_4"],
]

export const DIRECTIONS_ARRAY = [
  ["Północ", "kN"],
  ["Południe", "kS"],
  ["Wschód", "kE"],
  ["Zachód", "kW"],
]

export const TRUCKTYPES_ARRAY = [
  ["Kontener", "container"],
  ["Plandeka", "curtain"],
  ["Tandem", "tandem"],
  ["Wywrotka", "trolley"],
  ["Niskopodwoziowa", "low"],
  ["Chlodnia", "cold"],
  ["Cysterna", "tank"],
  ["Kłonicowa", "wood"],
  ["Autotransporter", "autotransporter"],
  ["Silos", "silos"],
]

export const WORKTYPES_ARRAY = [
  ["Staż", "internship"],
  ["Pełny etat", "fulltime"],
  ["3/4 etatu", "quatertime"],
  ["1/2 etatu", "parttime"],
]

export const WORKLOCATION_ARRAY = [
  ["W biurze", "office"],
  ["Hybrodowa", "hybrid"],
  ["Zdalnie", "remote"],
]

export const DRIVINGAREAS_ARRAY = [
  ["Krajowy", "national"],
  ["Miedzynarodowy", "international"],
  ["W obrębie miasta", "city"],
]

export const LANGUAGES_ARRAY = [
  ["Polski", "polish", "poland"],
  ["Angielski", "english", "great_britain"],
  ["Niemiecki", "german", "germany"],
  ["Ukraiński", "ukrainian", "ukraine"],
  ["Rosyjski", "russian", "russia"],
  ["Rumuński", "romanian", "romania"],
  ["Litewski", "lithuanian", "lithuania"],
  ["Estoński", "estonian", "estonia"],
  ["Czeski", "czech", "czech"],
  ["Białoruski", "byelorussian", "belarus"],
  ["Słowacki", "slovak", "slovakia"],
  ["Włoski", "italian", "italy"],
  ["Francuski", "french", "france"],
  ["Hiszpański", "spanish", "spain"],
  ["Portugalski", "portuguese", "portugal"],
  ["Norweski", "norwegian", "norway"],
  ["Szweski", "swedish", "sweden"],
  ["Turecki", "turkish", "turkey"],
  ["Other", "other", ""],
]
